export default "__VITE_ASSET__11f3ed8d__"